import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.3/js/sparta-ui-layers-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.3.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.5/js/sparta-validation-framework";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import "utilities/vendor/jsencrypt/2.3.1/js/jsencrypt";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.2/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import fingerprintUtility from "utilities/login/fingerprint-utility/2.0.0/js/fingerprint-utility";
import textInput from "utilities/helpers/helpers-text-inputs/4.1.0/js/helpers-text-inputs";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import checkbox from "utilities/helpers/helpers-checkbox/4.2.6/js/helpers-checkbox";
import checkboxHelper from "utilities/helpers/helpers-checkbox/4.2.6/js/helpers-checkbox";
import spartaHelpers from "utilities/helpers/helpers-sparta/2.3.5/js/helpers-sparta";
import radioButton from "utilities/helpers/helpers-radio-button/4.3.1/js/helpers-radio-button";
import select from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import helpersSelect from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import selectHelper from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import textAreaHelper from "utilities/helpers/helpers-textarea/2.1.1/js/helpers-textarea";
import spartaTemplates from "modules/login/ah-secure-signin-module/8.4.1/js/templates";
import "css!modules/login/ah-secure-signin-module/8.4.1/css/ah-secure-signin-module.scss.css";






export default class ahSecureSigninController {
    constructor(parentModule) {
        this.parentModule = parentModule;
        this._model = parentModule.model;
        this._view = parentModule.view;

        const self = this;
        this.bindThisConext(['_defineVars', '_bindEventHandlers', '_listen',
                '_subscribeEvents', '_initialize','compileAllTemplates'
            ],
            self, '');
    }

    bindThisConext(methods, context, suffix = 'Scoped') {
        const self = context;

        if (methods && $.isArray(methods) && methods.length > 0) {
            $(methods).each((index, method) => {
                if (self[method]) {
                    self[method + suffix] = self[method].bind(context);
                } else {
                    console.log(`Method: ${method} Not found in current context.`);
                }
            });
        }
    }

    _defineVars() {
        this.templates ={};
        this.$moduleContext = $(this.parentModule.view.settings.target);
        this.$moduleContext.spartaInputs();

        const _view = this.parentModule.view;
        this.$moduleContext = $(_view.settings.target);
        return this;
    }

    _bindEventHandlers() {
        return this;
    }

    _listen() {
        return this;
    }


    compileAllTemplates() {
        let
            allTemplates = this.$moduleContext.find('template[type="text/x-handlebars-template"]'),
            self = this;
            if(allTemplates.length >0 ){

                    self.templates[$(allTemplates[0]).attr('template-name')] =
                        Handlebars.compile(
                            $(allTemplates[0]).html().replace(/\[\[\[/g, '{{{')
                            .replace(/\[\[/g, '{{').replace(/\]\]\]/g, '}}}')
                            .replace(/\]\]/g, '}}'),
                        );

            }

        return self;
    }

    _subscribeEvents() {
        const main = this.parentModule;
        const controller = this.parentModule.controller;
        const self= this;

        main.Events.sub(cawEventsMasterUtility.EVENTS.INTERNAL.CAW_CLIENTPARAMS, (e) => {

            const widgetConfigData = {
                userData: e.data,
            };

            main.Store.addData('widgetConfigData', widgetConfigData);
            controller.emit({ context: 'update-widget-configdata', data: widgetConfigData });
        });


        main.supportedNamespaces = {};
        main.Events.sub("AH_UNIVERSAL_CAWOTP_READY", function(data) {
            main.otacNamespace = data.data['otac-namespace'];
        });

        main.Events.sub("AH_UNIVERSAL_CAWMTG_READY", function(data) {

            main.supportedNamespaces['mtg-namespace'] = data.data['mtg-namespace'];
        });

        if(typeof spaWidgetParams !=="undefined"){
            main.Events.pub(cawEventsMasterUtility.EVENTS.INTERNAL.SIGNIN_READY,'iswidget');
        }else{
            main.Events.pub(cawEventsMasterUtility.EVENTS.INTERNAL.SIGNIN_READY);
        }


        main._debug(`Subscribing to: ${cawEventsMasterUtility.EVENTS.FIRST_FACTOR_INIT}`);
        main.Events.sub(cawEventsMasterUtility.EVENTS.FIRST_FACTOR_INIT, (e) => {
            main._debug(`SecureSignin Module: ${JSON.stringify(e)}`);
            const defaultData = (main.widgetConfigData && main.widgetConfigData.userData) ?
                main.widgetConfigData.userData :
                main.widgetConfigData;

            e.data = {...defaultData,
                ..._.pick(e.data, ['channel', 'clientId', 'iv', 'lob', 'source',
                    'usecase', 'customClass', 'showSaveOIDCheck', 'cawToken',
                    'callbackTarget', 'preSignInValidate', 'client','pid', 'sm', 'keepSessionAlive', 'language','originatingFrom', 'scopeSelection', 'scope', 'tppType', 'clientName','domain'
                ])
            };


            main.Store.addData('widgetConfigData', e.data);
            if (e.data.usecase === 'tokenization' ||e.data.usecase === '' ) {
                controller.emit({ context: 'update-widget-configdata', data: e.data });
            }
            main.widgetConfigData.userData = e.data;
            if(e.data.domain){
                    this.parentModule.apiEndPoints = ahCawCommons.getEndPoints(this.parentModule.endpoints, e.data.domain);
            }
            const caWidgetLoadURL = this._getUrl('caWidgetLoadPersistUrl');

            const inputJson = {
                authenticationIdentifier: {
                    cawToken: e.data.cawToken,
                    initVector: e.data.iv,
                },
                filterRules: {
                    SOURCE: e.data.source,
                    USECASE: e.data.usecase,
                    LOB: e.data.lob,
                    CLIENT: e.data.clientId,
                    CHANNEL: e.data.channel,
                },
            };

            const ajaxOptions = {
                method: 'POST',
                data: JSON.stringify(inputJson),
                url: caWidgetLoadURL,
                crossDomain: true,
                cache: false,
                timeout: 60000,
                processData: false,
                xhrFields: {
                    withCredentials: true,
                },
                dataType: 'json',
                headers: {
                    'content-type': 'application/json',
                    accept: 'application/json',
                    'cache-control': 'no-cache',
                },
            };
            const initiateCall = new ahCawTransportUtility();
            initiateCall._serviceCall(ajaxOptions, (response) => {
                const data = response.responseData;
                let polling = { "polling": false};
                if (data && data.status && data.status === 'SUCCESS') {
                    main._debug(`Init Success: ${JSON.stringify(data)}`);
                    const widgetConfigData = {};
                    widgetConfigData.initData = data;
					if(main.widgetConfigData && main.widgetConfigData.userData && main.widgetConfigData.userData.originatingFrom === "ATP-CAW") {
						let atpOnlineIDSaved = (main.SpartaFunctions.spartaGetCookie('atp_signin_prefill_multi_secure').trim()).split('||');
						let atponlineIdList = [];
						for(var i=0;i<atpOnlineIDSaved.length;i++) {
							if(atpOnlineIDSaved[i].split(':')[0]) {
								atponlineIdList.push(atpOnlineIDSaved[i].split(':')[0]);
							}
						}
					    widgetConfigData.initData.onlineIdlist = atponlineIdList;
					}

					                    widgetConfigData.userData = e.data;
                    controller.emit({ context: 'update-widget-configdata', data: widgetConfigData });
                    controller.emit({ context: 'redrawForDigitalID', data: widgetConfigData });
                    main.Events.pub(cawEventsMasterUtility.EVENTS.WIDGET_LOAD_SUCCESS, widgetConfigData.userData);

                    if (typeof data.cawSwitches !== 'undefined' && data.cawSwitches['caw.cc.switch'] === 'true') {
                        const basePath = ahCawCommons.getBasePath(main.spaParams);
                        fingerprintUtility._browserfingerprint(`${basePath}/login/rest/sas/sparta/iac`);
                    }
                    let widgetJCRInfo = main.Store.getData('WidgetJCRData');
                    main.Store.addData('WidgetInitData',widgetConfigData.initData);


					                } else {
                    main._debug(`Init Failed: ${JSON.stringify(data)}`);
                    main.Events.pub(cawEventsMasterUtility.EVENTS.WIDGET_LOAD_FAILED, "");
                }
                main.Events.pub(cawEventsMasterUtility.EVENTS.CAW_KEY, data.publicKey);
                main.Events.pub("handlePolling", polling);

            }, (jqXHR, exception, errorThrown) => {
                main._debug('Error in loading CAWidgetLoad!');
                let flowName = main.Store.getData('widgetConfigData');

                if (typeof flowName !== "undefined" && flowName.usecase === 'tokenization') {
                    let errorInfo = { "errorCode": "" };
                    errorInfo.errorCode = "EG";
                    errorInfo.origin = "signIn";
                    main.Events.pub("TOKENIZATION_ERROR_HANDLING", errorInfo);
                }
                main.Events.pub(cawEventsMasterUtility.EVENTS.WIDGET_LOAD_FAILED, jqXHR);
            });
        }, true);

        return this;
    }

    _initialize() {
        this._defineVars()
            ._bindEventHandlers()
            ._subscribeEvents()
            ._listen();
        this.compileAllTemplates();
    }

    _getUrl(urlCode) {
        let prefix;
        if (
            _.get(this.parentModule.widgetConfigData, 'sm') === 'true' ||
            _.get(this.parentModule.widgetConfigData, 'userData.sm') === 'true' ||
            _.get(this.parentModule.widgetConfigData, 'sm') === true ||
            _.get(this.parentModule.widgetConfigData, 'userData.sm') === true
        ) {
            prefix = 'sm';
        } else if (_.get(this.parentModule.widgetConfigData, 'usecase') === 'tokenization' || _.get(this.parentModule.widgetConfigData, 'userData.usecase') === 'tokenization') {
            prefix = 'tokenize';
        } else if (
            _.get(this.parentModule.widgetConfigData, 'keepSessionAlive') === 'true' ||
            _.get(this.parentModule.widgetConfigData, 'userData.keepSessionAlive') === 'true' ||
            _.get(this.parentModule.widgetConfigData, 'keepSessionAlive') === true ||
            _.get(this.parentModule.widgetConfigData, 'userData.keepSessionAlive') === true
        ) {
            prefix = 'keepsession';
        } else {
            prefix = 'default';
        }

        if (urlCode === 'caWidgetLoadUrl' || urlCode === 'caWidgetLoadPersistUrl' || urlCode === 'verifyAuthUrl' || urlCode === 'initAuthUrl') {
            return this.parentModule.apiEndPoints[`${prefix}-${urlCode}`] ?
                this.parentModule.apiEndPoints[`${prefix}-${urlCode}`] :
                this.parentModule.apiEndPoints[`${'default' + '-'}${urlCode}`];
        }
        this._debug('Incorrect urlCode');
        return '//incorrect urlCode';
    }

}
